import { useContext, useMemo } from 'react'
import CheckoutContext from './context'

export default function useCheckout() {
  const context = useContext(CheckoutContext)
  return useMemo(() => context, [context])
}
